module.exports = __webpack_public_path__ + "static/img/Graham-Wright.42cfac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Graham-Wright.jpg
// module id = YLA1
// module chunks = 1